<template>
  <div data-testid="financialclose-project-users" class=" d-flex justify-center">
    <div class="all-width" data-testid="financialclose-project-users__container">
      <v-card class="shadow-off" loader-height="2" :loading="loading" :disabled="loading" data-testid="financialclose-project-users__main-card">
        <v-card-text data-testid="financialclose-project-users__main-card-text">
          <div class="d-flex align-center mb-1" data-testid="financialclose-project-users__headerbar">
            <div>
              <div class="d-flex" data-testid="financialclose-project-users__breadcrumb">
                <p class="mb-1" data-testid="financialclose-project-users__breadcrumb-home">Home</p>
                <p class="px-2 mb-1" data-testid="financialclose-project-users__breadcrumb-sep">/</p>
                <p class="mb-1" data-testid="financialclose-project-users__breadcrumb-desc">{{ metadata.description }}</p>
              </div>
              <div class="d-flex align-center justify-start" data-testid="financialclose-project-users__titlebar">
                <h3 class="black--text ma-0  pt-1 font-weight-semibold" data-testid="financialclose-project-users__title">Users</h3>
                <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="shadow-off ml-1 pt-1" icon @click="refreshData()" data-testid="financialclose-project-users__refresh-btn">
                      <v-icon size="26" data-testid="financialclose-project-users__refresh-icon">mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
                <activity-log 
                  :resource-id="metadata._id" 
                  data-testid="financialclose-project-users__activitylog"
                  row-description="User Management"
                  :type="$options.ACTIVITY_LOG_TYPES.USERS"
                />
              </div>
            </div>
          </div>
          <div v-if="loading && !metadata._id" data-testid="financialclose-project-users__loading">
            <v-skeleton-loader type="table-heading, list-item-two-line, article, article" data-testid="financialclose-project-users__loading-skeleton"></v-skeleton-loader>
          </div>
          <div v-else data-testid="financialclose-project-users__main-content">
            <div class="mb-8" data-testid="financialclose-project-users__section-users">
              <div class="d-flex  align-center" data-testid="financialclose-project-users__section-users-header">
                <h5 class="text-font-size-md font-weight-regular" data-testid="financialclose-project-users__section-users-title">Associated Users</h5>
                <v-spacer></v-spacer>
                <v-btn color="primary"  class="white--text mb-1 shadow-off" @click="associateUserDialogBox()" v-if="managerlist.indexOf(userid) > -1 && ($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add'))" data-testid="financialclose-project-users__adduser-btn">
                  <v-icon class="mr-1" data-testid="financialclose-project-users__adduser-icon">mdi-plus</v-icon><span data-testid="financialclose-project-users__adduser-label">User</span></v-btn>
                </div>
                <lb-datatableaction v-if="formattedUsersSource.length>0" :headers="userTableHeaders" :tabledata="formattedUsersSource" :displayedRowCount="formattedUsers.length" :itemsperpage="itemsPerPage" searchterm="" :bulkActions="false" :showToolbar="true" :selectfilter="userFilterCriteria" @filter-item="applyUserFilters" @clear-item="clearUserFilters" data-testid="financialclose-project-users__datatable-users">
                  <template v-slot:tbody>
                    <tr v-for="item in formattedUsers" :key="item._id" class="financialclose-project-users__row" :class="{ 'low-opacity': item.status === false }" data-testid="financialclose-project-users__row">
                      <template v-for="header in userTableHeaders">
                        <td v-if="header.visible && header.value !== 'action'" class="px-2" :key="header.value" :class="{ 'description-header': header.value === 'description', '': header.value !== 'description', textLowercase: header.value === 'email' }" data-testid="financialclose-project-users__cell">
                          <div v-if="header.value === 'type'">
                          <v-chip label v-if="item.type === 'manager'" color="lightpurple" class="font-weight-bold caccounting--text" data-testid="financialclose-project-users__chip-manager"><span>Manager</span></v-chip>
                          <v-chip label v-else-if="item.type === 'general'" color="lightgreen" class="font-weight-bold green--text" data-testid="financialclose-project-users__chip-general"><span>General</span></v-chip>
                          <v-chip label v-else color="lightred" class="error--text font-weight-bold" data-testid="financialclose-project-users__chip-unknown"><span>Unknown</span></v-chip>
                        </div>
                        <div v-else-if="header.value === 'tasklist'">
                          <v-tooltip bottom content-class="tooltip-bottom" v-if="(item.tasklist || {}).preparer">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightblue" class="blue--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-preparer"><span>{{item.tasklist.preparer}}</span></v-chip>
                            </template>
                            <span>Preparer</span>
                          </v-tooltip>
                          <v-tooltip bottom content-class="tooltip-bottom" v-if="(item.tasklist || {}).approver">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightyellow" class="yellow--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-approver"><span>{{item.tasklist.approver}}</span></v-chip>
                            </template>
                            <span>Approver</span>
                          </v-tooltip>
                        </div>
                        <div v-else-if="header.value === 'progress'">
                          <div v-if="(((item.progress || {}).preparer || 0) + ((item.progress || {}).approver || 0)) > 0" style="max-width:100px;margin:auto" data-testid="financialclose-project-users__progress-bar">
                            {{ (((((item.progress || {}).completed || 0)/(((item.progress || {}).preparer || 0) + ((item.progress || {}).approver || 0))) || 0)*100).toFixed(0) }}%
                            <v-progress-linear :height="10" color="green"
                            :value="Math.max(((((item.progress || {}).completed || 0)/(((item.progress || {}).preparer || 0) + ((item.progress || {}).approver || 0))) || 0)*100,2)" data-testid="financialclose-project-users__progress-linear">
                            </v-progress-linear>
                          </div>
                          <div v-else data-testid="financialclose-project-users__progress-empty"></div>
                        </div>
                        <span v-else-if="header.value === 'name'">
                          <template v-if="(item.name || '').includes('(Inactive)')">
                            {{ (item.name || '').replace(' (Inactive)', '') }}
                            <span class="error--text"> (Inactive)</span>
                          </template>
                          <template v-else>
                            {{ getItemData(item, header.value) }}
                          </template>
                        </span>
                        <span v-else> {{ getItemData(item, header.value) }}</span>
                      </td>
                    </template>
                    <td class="d-flex align-center px-3 border-right border-left action-data" data-testid="financialclose-project-users__actions">
                      <div v-if="($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add'))">
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="item._id!==userid && managerlist.indexOf(userid) > -1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="manageUser('move', item.type, item._id)" data-testid="financialclose-project-users__action-move-btn">
                              <v-icon data-testid="financialclose-project-users__action-move-icon">mdi-sync</v-icon>
                            </v-btn>
                          </template>
                          <span v-if="item.type === 'general'">Change to Manager User</span>
                          <span v-else>Change to General User</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="item._id!==userid && managerlist.indexOf(userid) > -1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="deleteUserDialogBox(item)" data-testid="financialclose-project-users__action-remove-btn">
                              <v-icon data-testid="financialclose-project-users__action-remove-icon">mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Remove User</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="managerlist.indexOf(userid) > -1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="replaceUserDialog(item._id, item.type)" data-testid="financialclose-project-users__action-replace-btn">
                              <v-icon data-testid="financialclose-project-users__action-replace-icon">mdi-account-convert</v-icon>
                            </v-btn>
                          </template>
                          <span>Replace User</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </template>
              </lb-datatableaction>
              <div class="d-flex align-center justify-center" v-else data-testid="financialclose-project-users__empty-state-users">
                NO DATA
              </div>
              <div class="d-flex py-2 align-center" data-testid="financialclose-project-users__section-infoowners-header">
                <h5 class="text-font-size-md font-weight-regular" data-testid="financialclose-project-users__section-infoowners-title">Information Owners</h5>
                <v-spacer></v-spacer>
              </div>
              <lb-datatableaction v-if="formattedInfoOwnersSource.length>0" :headers="infoOwnerTableHeaders" :tabledata="formattedInfoOwnersSource" :displayedRowCount="formattedInfoOwners.length" :itemsperpage="itemsPerPage" searchterm="" :bulkActions="false" :showToolbar="true" :selectfilter="infoOwnerFilterCriteria" @filter-item="applyInfoOwnerFilters" @clear-item="clearInfoOwnerFilters" data-testid="financialclose-project-users__datatable-infoowners">
                <template v-slot:tbody>
                  <tr v-for="item in formattedInfoOwners" :key="item._id" class="financialclose-project-users__row-infoowner" :class="{ 'low-opacity': item.status === false }" data-testid="financialclose-project-users__row-infoowner">
                    <template v-for="header in infoOwnerTableHeaders">
                      <td v-if="header.visible && header.value !== 'action'" class="px-2 single-line" :key="header.value" :class="{ 'description-header': header.value === 'description', 'single-line': header.value !== 'description', textLowercase: header.value === 'email' }" data-testid="financialclose-project-users__cell-infoowner">
                        <div v-if="header.value === 'progress' " style="max-width:100px;margin:auto" data-testid="financialclose-project-users__progress-bar-infoowner">
                          {{ ((((item.approved)/(item.requested+item.pending+item.approved+item.cancelled)) || 0)*100).toFixed(0) }}%
                          <v-progress-linear :height="10" color="green" :value="Math.max((((item.approved)/(item.requested+item.pending+item.approved+item.cancelled)) || 0)*100,2)" data-testid="financialclose-project-users__progress-linear-infoowner">
                          </v-progress-linear>
                        </div>
                        <div v-else-if="header.value === 'information'">
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightpurple" class="caccounting--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-infoowner-total"><span>{{item.requested+item.pending+item.approved+item.cancelled}}</span></v-chip>
                            </template>
                            <span>Total requests</span>
                          </v-tooltip>
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightblue" class="blue--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-infoowner-requested"><span>{{item.requested}}</span></v-chip>
                            </template>
                            <span>Yet to respond</span>
                          </v-tooltip>
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightyellow" class="yellow--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-infoowner-pending"><span>{{item.pending}}</span></v-chip>
                            </template>
                            <span>Waiting for approval</span>
                          </v-tooltip>
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightgreen" class="green--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-infoowner-approved"><span>{{item.approved}}</span></v-chip>
                            </template>
                            <span>Approved</span>
                          </v-tooltip>
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip label color="lightred" class="error--text mr-1 font-weight-bold" v-bind="attrs" v-on="on" data-testid="financialclose-project-users__chip-infoowner-cancelled"><span>{{item.cancelled}}</span></v-chip>
                            </template>
                            <span>Cancelled</span>
                          </v-tooltip>
                        </div>
                        <span v-else> {{ getItemData(item, header.value) }}</span>
                      </td>
                    </template>
                    <td class="d-flex align-center px-3 single-line border-right border-left action-data" data-testid="financialclose-project-users__actions-infoowner">
                      <v-tooltip bottom content-class="tooltip-bottom" v-if="managerlist.indexOf(userid) > -1 && ($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add'))">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on" @click="replaceInfoOwnerDialog(item)" data-testid="financialclose-project-users__action-replace-infoowner-btn">
                            <v-icon data-testid="financialclose-project-users__action-replace-infoowner-icon">mdi-account-convert</v-icon>
                          </v-btn>
                        </template>
                        <span>Replace Information Owner</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </lb-datatableaction>
              <div class="d-flex align-center justify-center" v-else data-testid="financialclose-project-users__empty-state-infoowners">
                NO DATA
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <lb-drawer v-model="infoownerdialog" heading="Change Information Owner" width="400" :loading="infoownerloading" data-testid="financialclose-project-users__infoownerdrawer">
        <template v-slot:body>
          <div data-testid="financialclose-project-users__infoownerdrawer-body">
            <v-row>
              <v-col cols="12" class="my-0 py-1">
                <lb-dropdown v-model="infoownerchangetype" label="Type*" :items="[{name: 'New', value: 'new'},{name: 'Existing', value: 'existing'}]" itemtext="name" itemvalue="value" data-testid="financialclose-project-users__infoownerdrawer-type" />
              </v-col>
              <v-col cols="12" class="my-0 py-1" v-if="infoownerchangetype === 'existing'">
                <lb-dropdown label="New Owner*" v-model="infoownerdata.newownerid" :items="possibleinfoowners" itemtext="displayName" itemvalue="_id" data-testid="financialclose-project-users__infoownerdrawer-newowner" />
              </v-col>
              <v-col cols="12" class="my-0 py-1" v-if="infoownerchangetype === 'new'">
                <lb-string label="Name*" v-model="infoownerdata.name" data-testid="financialclose-project-users__infoownerdrawer-name" />
              </v-col>
              <v-col cols="12" class="my-0 py-1" v-if="infoownerchangetype === 'new'">
                <lb-string label="Email*" v-model="infoownerdata.email" data-testid="financialclose-project-users__infoownerdrawer-email" />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="replaceInfoOwner()" :disabled="!(infoownerdata.newownerid || (infoownerdata.name && infoownerdata.email))" data-testid="financialclose-project-users__infoownerdrawer-update-btn"><span data-testid="financialclose-project-users__infoownerdrawer-update-label">Update</span></v-btn>
        </template>
      </lb-drawer>

      <lb-drawer v-model="associateuserdialog" heading="Add User" width="400" :loading="associateuserloading" data-testid="financialclose-project-users__associateuserdrawer">
        <template v-slot:body>
          <div data-testid="financialclose-project-users__associateuserdrawer-body">
            <v-row>
              <v-col cols="12" class="my-0 py-1">
                <lb-dropdown label="User*" v-model="associateuserdata.userid" :items="associateuserlist" itemtext="name" itemvalue="_id" :error="associateusererror.userid" data-testid="financialclose-project-users__associateuserdrawer-user" />
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <lb-dropdown v-model="associateuserdata.type" label="Type*" :items="usertypes" itemtext="name" itemvalue="value" :error="associateusererror.type" data-testid="financialclose-project-users__associateuserdrawer-type" />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="manageUser('associate',associateuserdata.type,associateuserdata.userid)"  :disabled="!associateuserdata.type || !associateuserdata.userid" data-testid="financialclose-project-users__associateuserdrawer-add-btn"><span data-testid="financialclose-project-users__associateuserdrawer-add-label">Add</span></v-btn>
        </template>
      </lb-drawer>

      <lb-drawer v-model="replaceuserdialog" heading="Replace User" width="500" :loading="replaceuserloading" data-testid="financialclose-project-users__replaceuserdrawer">
        <template v-slot:body>
          <div data-testid="financialclose-project-users__replaceuserdrawer-body">
            <div class="mb-3" data-testid="financialclose-project-users__replaceuserdrawer-fromuser-row">
              <span class="font-weight-bold mr-2">From User:</span>
              <span class="noTransform" data-testid="financialclose-project-users__replaceuserdrawer-fromuser">{{(userdata[replaceuserid] || {}).displayname || 'Unknown'}}</span>
            </div>
            <lb-dropdown label="To User*" v-model="replaceuserdata.userid" :items="replaceuserlist" itemtext="displayname" itemvalue="_id" data-testid="financialclose-project-users__replaceuserdrawer-touser" item-class="noTransform" />
            <div v-if="(userchecklistcount[replaceuserid] || {}).preparer || (userchecklistcount[replaceuserid] || {}).approver" data-testid="financialclose-project-users__replaceuserdrawer-warning">
              <div data-testid="financialclose-project-users__replaceuserdrawer-warning-text1">Since the user is also associated to various tasklist items, all those association will be replaced with the new user.</div>
              <div data-testid="financialclose-project-users__replaceuserdrawer-warning-text2"><span class="font-weight-bold mr-2">Note:</span>If the new user is already assigned to the tasklist item in a different capacity, then they will not be re-assigned.</div>
              <div class="font-weight-bold" data-testid="financialclose-project-users__replaceuserdrawer-warning-text3">Do you want to proceed?</div>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="replaceUser()" :disabled="!replaceuserdata.userid" data-testid="financialclose-project-users__replaceuserdrawer-replace-btn"><span data-testid="financialclose-project-users__replaceuserdrawer-replace-label">Replace</span></v-btn>
        </template>
      </lb-drawer>

      <lb-drawer v-model="deleteuserdialog" heading="Remove User" width="500" :loading="deleteuserloading" data-testid="financialclose-project-users__deleteuserdrawer">
        <template v-slot:body>
          <div data-testid="financialclose-project-users__deleteuserdrawer-body">
            <div class="mb-3" data-testid="financialclose-project-users__deleteuserdrawer-selecteduser-row">
              <span class="font-weight-bold mr-2">Selected User:</span>
              <span class="" data-testid="financialclose-project-users__deleteuserdrawer-selecteduser">{{(deleteuserdata || {}).name || 'Unknown'}}</span>
            </div>
            <div v-if="(userchecklistcount[deleteuserdata._id] || {}).preparer || (userchecklistcount[deleteuserdata._id] || {}).approver" data-testid="financialclose-project-users__deleteuserdrawer-warning">
              Since the user is also associated to various tasklist items, all those association will be removed if the user is removed from the project.
            </div>
            <div v-else data-testid="financialclose-project-users__deleteuserdrawer-warning-alt">This will remove the user from the current project.</div>
            <div class="font-weight-bold" data-testid="financialclose-project-users__deleteuserdrawer-warning-confirm">Do you want to proceed?</div>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="manageUser('remove', deleteuserdata.type, deleteuserdata._id)()" data-testid="financialclose-project-users__deleteuserdrawer-remove-btn"><span data-testid="financialclose-project-users__deleteuserdrawer-remove-label">Remove</span></v-btn>
        </template>
      </lb-drawer>

    </div>
  </div>
</template>
<script>
import { MESSAGES, ACTIVITY_LOG_TYPES } from '../../utils/constants';
import ActivityLog from '../../components/ActivityLog/ActivityLog.vue';
import { NONE_SENTINEL } from '@/views/common/DataTableAction/constants';
    export default {
        name: 'financialclose_project_users',
        // Expose constant for template interpolation via $options
        ACTIVITY_LOG_TYPES,
        // props: ['props'],
        data: function(){
          return {
            right:"financialclose_project",
            metadata: {},
            checklist: [],
            pbcdata: {},
            userchecklistcount: {},
            userid: "",
            formdata: {},
            userdata: {},
            stage: -1,      
            id: "",
            loading: false,
      
            associateuserdialog: false,
            associateuserloading: false,
            associateuserdata: {},
            associateusererror: {},
            associateuserlist: [],
            infoownerchangetype: "",
            oldinfoownerdata: {},
            infoownerdialog: false,
            infoownerloading: false,
            infoownerdata: {},
            allinfoowners: [],
            userlist: [],
            managerlist: [],
            infoowners: [],
            possibleinfoowners: [],
            replaceuserdialog: false,
            replaceuserloading: false,
            replaceuserid: "",
            replaceuserdata: {},
            replaceuserlist: [],
            deleteuserdialog: false,
            deleteuserloading: false,
            deleteuserdata: {},
            usertypes: [
              { name: "General user", value: "general" },
              { name: "Manager user", value: "manager" }
            ],
            userTableHeaders: [
              {
                value: "indexno",
                text: "SL No",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "name",
                text: "Name",
                sortable: true,
                filterable: true,
                visible:true,
              },
              {
                value: "email",
                text: "Email",
                sortable: true,
                filterable: true,
                visible:true,
              },
              {
                value: "type",
                text: "Type",
                sortable: true,
                filterable: true,
                visible:true,
              },
              {
                value: "tasklist",
                text: "Tasklist Items",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "progress",
                text: "Progress",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "action",
                text: "Action",
                sortable: false,
                filterable: false,
                visible:true,
              }
            ],
            infoOwnerTableHeaders: [
              {
                value: "indexno",
                text: "SL No",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "name",
                text: "Name",
                sortable: true,
                filterable: true,
                visible:true,
              },
              {
                value: "email",
                text: "Email",
                sortable: true,
                filterable: true,
                visible:true,
              },
              {
                value: "information",
                text: "Information Requests",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "progress",
                text: "Progress",
                sortable: false,
                filterable: false,
                visible:true,
              },
              {
                value: "action",
                text: "Action",
                sortable: false,
                filterable: false,
                visible:true,
              }
            ],
            formattedUsers: [],
            formattedUsersSource: [],
            userFilterCriteria: {},
            formattedInfoOwners: [],
            formattedInfoOwnersSource: [],
            infoOwnerFilterCriteria: {},
            headersPushed: false,
            activitylogconfig: {
              userassociate: {
                icon: "mdi-plus",
                color: "info",
                displaytext: "User Associated",
              },
              userreplaced: {
                icon: "mdi-account-convert",
                color: "info",
                displaytext: "User Replaced",
              },
              userremoved: {
                icon: "mdi-close",
                color: "error",
                displaytext: "User Removed",
              },
              usermoved: { icon: "mdi-sync", color: "", displaytext: "Updated" },
            },
            itemsPerPage:10,
            projectUsersWithChecklistData: [],
            projectUserIds: [],
            userDetails:{ activeUserIds: [] }
          }
        },
        components: {
         ActivityLog
        },
        created() {
          this.refreshData();
        },
        activated() {
          this.refreshData();
        },
        methods: {
          getItemData(item, key) {
            return item[key];
          },
          formatUserData() {
            let formattedUser = {};
            let formattedUsers = [];
            this.projectUsersWithChecklistData.forEach((item, index) => {
              formattedUser = {
                __key: index,
                __formatedkey: index,
                _id: item._id,
                indexno: index + 1,
                name: this.userDetails?.activeUserIds?.includes(item._id) ? item.name : (item.name || 'Unknown') + ' (Inactive)',
                email: item.email,
                color: item.color,
                type: item.type,
                tasklist: item.tasklist,
                progress: item.progress,
              };
              formattedUsers.push(formattedUser);
            });
            this.formattedUsers = formattedUsers;
            this.formattedUsersSource = formattedUsers.slice();
          },
          formatInfoOwnerData(){
            let formattedInfoOwner = {};
            let formattedInfoOwners = [];
            this.infoowners.forEach((item, index) => {
              formattedInfoOwner = {
                __key: index,
                __formatedkey: index,
                _id: item._id,
                indexno: index + 1,
                name: item.info_owner_detail?.name || '',
                email: item.info_owner_detail?.email || '',
                approved:item.approved,
                cancelled:item.cancelled,
                pending:item.pending,
                requested:item.requested,
                info_owner_detail:item.info_owner_detail,
                info_owner:item.info_owner,
              };
              formattedInfoOwners.push(formattedInfoOwner);
            });
            
            this.formattedInfoOwners = formattedInfoOwners;
            this.formattedInfoOwnersSource = formattedInfoOwners.slice();
          },
          refreshData() {
            this.id = this.$route.params.id || "";
            this.userid = this.$store.state.user.id;
            this.getAllActiveUsers();
            this.getData();
          },
          getData() {
            this.loading = true;
            return this.axios.post("/v2/financialclose/analysis/getuserdetails/"+this.id).then(dt => {
              if(dt.data.status === "success" && dt.data.data.length > 0){
                let data = dt.data.data[0] || {}
                this.metadata = data.metadata || {};
                this.userlist = [];
                this.userlist = this.metadata.userlist || [];
                this.managerlist = [];
                this.managerlist = this.metadata.managerlist || [];
                this.stage = this.metadata.stage;
                this.userchecklistcount = data.userchecklistcount || {};
                this.infoowners = data.infoowners || [];
                this.projectUserIds = this.userlist.concat(this.managerlist);
                this.formatInfoOwnerData();
              }
            }).catch(err => {
              this.$store.commit("sbError", err.message || err || "Unknown error!");
              console.log(err);
            }).then(() => {
              return this.axios.post("/v2/financialclose/analysis/getusersformdata");
            }).then(dt => {
              if(dt.data.status === "success"){
                this.formdata = dt.data.data[0] || {};
                
                this.allinfoowners = this.formdata.infoowners || [];
                this.userdata = {};
                const matchedUsers = this.formdata.users.filter(user => this.projectUserIds.includes(user._id));
                let colors = this.$nova.getColors((this.formdata.users || []).length, 0.2);
                for (let i = 0; i < (this.formdata.users || []).length; i++) {
                  const el = (this.formdata.users || [])[i];
                  this.userdata[el._id] = el;
                  this.userdata[el._id].color = colors[i];            
                }
                
                // this.matchUsersWithData(this.projectUserIds, this.userchecklistcount, this.managerlist, this.userlist);
                this.projectUsersWithChecklistData = this.matchUsersWithData(matchedUsers, this.userchecklistcount, this.managerlist, this.userlist);
                this.formatUserData();
              }else throw new Error(dt.data.message);
            }).catch(err => {
              this.$store.commit("sbError", err.message || err || "Unknown error!");
            }).finally(() => {
              this.loading = false;
            })
          },
        async getAllActiveUsers(){
            try{
              await this.$store.dispatch("tasks/getAllUsersWithStatus",{isActiveUsersRequired:true})
              this.$set(this.userDetails, 'activeUserIds', this.$store.getters["tasks/getActiveUsersIds"] || []);
            }catch(error){
              console.error("Error fetching users:", error);
              this.$store.commit("sbError", MESSAGES.FAILED_TO_GET_USERS);
              this.$set(this.userDetails, 'activeUserIds', []);
            }
          },
          deleteUserDialogBox(data) {
            this.deleteuserdata = {...data};
            this.deleteuserdialog = true;
          },
          associateUserDialogBox() {
            this.associateuserdata = {};
            this.associateuserlist = [];
            for (const k in this.formdata.users) {
              if (Object.hasOwnProperty.call(this.formdata.users, k)) {
                const el = this.formdata.users[k];
                if(this.managerlist.indexOf(el._id) === -1 && this.userlist.indexOf(el._id) === -1 && this.userDetails?.activeUserIds?.includes(el._id)) this.associateuserlist.push(el);
              }
            }
            this.associateuserdialog = true;
            this.associateusererror = {};
          },
          replaceInfoOwnerDialog(d) {
            this.infoownerdata = {};
            this.oldinfoownerdata = d;
            this.possibleinfoowners = [];
            for (const i of this.allinfoowners) {
              if(i._id !== d._id && i.status) {
                const ownerName = i.name || '';
                const ownerEmail = i.email || '';
                this.possibleinfoowners.push({
                  ...i,
                  displayName: ownerEmail ? `${ownerName} (${ownerEmail})` : ownerName,
                });
              }
            }
            this.infoownerchangetype = "existing";
            this.infoownerdialog = true;
          },
          replaceInfoOwner() {
            this.infoownerdata.oldownerid = this.oldinfoownerdata._id;
            this.infoownerdata.type = this.infoownerchangetype;
            this.infoownerloading = true;
            this.infoownerdata.cycleid = this.metadata._id;
            this.axios.post("/v2/financialclose/project/manageinfoowner/" + this.metadata.pbcproject, {data: [this.infoownerdata]}).then(dt => {
              if(dt.data.status === "success"){
                this.$store.commit("sbSuccess", "Information owner changed");
                this.getData()
              }else throw dt.data.message || "Error changing status";
            }).catch(err => {
              this.$store.commit("sbError", err.message || err || "Unknown error!");
              console.log(err);
            }).finally(() => {
              this.infoownerloading = false;
              this.infoownerdialog = false;
            });
          },
          validateAssociateUserData(data) {
          const errors = {};
          // User ID validation
          if (
            !data.userid ||
            typeof data.userid !== 'string' ||
            data.userid.trim().length < 2
          ) {
            errors.userid = 'User is required.';
          }
          // Type validation
          if (
            !data.type ||
            typeof data.type !== 'string' ||
            data.type.trim().length < 2
          ) {
            errors.type = 'Type is required';
          }
          return errors;
        },
      
          manageUser(type, usertype = "general", uid = "", fromuserid = "") {
           
            let data = {};
            if (type === "associate") {
              const errors = this.validateAssociateUserData({userid:uid,type:usertype});
              this.associateusererror = errors; // Assign errors for UI display
              if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", 'required fields are missing or invalid.');
                return;
              }
              this.associateuserloading = true;
              data = { userid: uid, usertype: usertype, type: "associate" };
            } else if (type === "move") {
              if(!this.userDetails?.activeUserIds?.includes(uid)){
                this.$store.commit("sbError", MESSAGES.SELECTED_INACTIVE_USERS);
                return;
              }
              this.loading = true;
              data = { userid: uid, usertype: usertype, type: "move" };
            } else if (type === "remove") {
              this.deleteuserloading = true;
              data = { userid: uid, usertype: usertype, type: "remove" };
            } else if (type === "replace") {
              this.deleteuserloading = true;
              this.replaceuserloading = true;
              data = { touserid: uid, usertype: usertype, type: "replace", fromuserid: fromuserid };
            } 
            let successflag = false;
            this.axios.post("/v2/financialclose/project/manageuser/" + this.metadata._id, { data: [data] })
              .then(dt => {
                if (dt.data.status === "success") {
                  this.associateuserdialog = false;
                  this.deleteuserdialog = false;
                  const successMessages = {
                    associate: "User Associated",
                    move: "User Changed",
                    remove: "User Removed",
                    replace: "User Replaced User"
                  };
                  this.$store.commit("sbSuccess", successMessages[type]);
                  if (type === "replace") {
                    this.replaceuserloading = false;
                    this.replaceuserdialog = false;
                    successflag = true;
                  }
                  if (!successflag) {
                    this.refreshData();
                  }
                } else {
                  throw new Error(dt.data.message || "Error changing status");
                }
              })
              .catch(err => {
                const errMessage = err?.response?.data?.message || err?.message || err || "Unknown error!";
                this.$store.commit("sbError", errMessage);
                if (type === "replace") {
                  this.replaceuserdialog = false;
                }
                console.log(err);
              })
              .finally(() => {
                this.loading = false;
                this.deleteuserloading = false;
                this.associateuserloading = false;
                this.replaceuserloading = false;
                if (successflag) this.refreshData();
              });
        },
      
          replaceUserDialog(uid, type) {
            this.replaceuserdata = {type: type};
            this.replaceuserlist = [];
            this.replaceuserid = uid;
            for (const k in this.formdata.users) {
              if (Object.hasOwnProperty.call(this.formdata.users, k)) {
                const el = this.formdata.users[k];
                if(el._id !== uid && this.userDetails?.activeUserIds?.includes(el._id)) this.replaceuserlist.push(el);
              }
            }
            this.replaceuserdialog = true;
          },
           replaceUser(){
            let fromuserid = this.replaceuserid;
            let touserid = this.replaceuserdata.userid;
            let type = this.replaceuserdata.type;
            this.manageUser("replace",type,touserid,fromuserid)
          },
          _cleanFilterCriteria(item) {
            return Object.entries(item || {}).reduce((acc, [key, values]) => {
              if (Array.isArray(values)) {
                const real = values.filter(v => v !== NONE_SENTINEL);
                if (real.length > 0) acc[key] = real;
              } else if (values !== undefined && values !== null) {
                acc[key] = values;
              }
              return acc;
            }, {});
          },
          applyUserFilters(item) {
            this.userFilterCriteria = item;
            this.formattedUsers = this.$nova.filterByDynamicCriteria(this.formattedUsersSource, this._cleanFilterCriteria(item));
          },
          clearUserFilters() {
            this.userFilterCriteria = {};
            this.formattedUsers = this.formattedUsersSource.slice();
          },
          applyInfoOwnerFilters(item) {
            this.infoOwnerFilterCriteria = item;
            this.formattedInfoOwners = this.$nova.filterByDynamicCriteria(this.formattedInfoOwnersSource, this._cleanFilterCriteria(item));
          },
          clearInfoOwnerFilters() {
            this.infoOwnerFilterCriteria = {};
            this.formattedInfoOwners = this.formattedInfoOwnersSource.slice();
          },
        matchUsersWithData(users, dataObject, managerList, userList) {
          
        return Object.entries(dataObject).map(([id, values]) => {
          console.log(values);
          
          const user = users.find(user => user._id === id);
          if (user) {
            const type = managerList.includes(id) ? "manager" : userList.includes(id) ? "general" : "unknown";
            return {
              name: user.name,
              email: user.email,
              tasklist: this.userchecklistcount[user._id],
              progress: this.userchecklistcount[user._id],
              type: type,
              _id:user._id
            };
          }
          return null;
        }).filter(item => item !== null);
      }
    
         
        },
        computed: {
          finaluserlist(){
            let nl = [];
            for (const i of this.managerlist) {
              let ud = {...this.userdata[i]};
              ud.type = "manager";
              nl.push(ud);
            }
            for (const i of this.userlist) {
              let ud = {...this.userdata[i]};
              ud.type = "general";
              nl.push(ud);
            }
            return nl;
          }
        },
        watch: {
          "infoownerchangetype": function(d){
            this.infoownerdata.type = d;
          },
          formattedUsersSource(newList) {
            const cleaned = this._cleanFilterCriteria(this.userFilterCriteria);
            if (Object.keys(cleaned).length > 0) {
              this.formattedUsers = this.$nova.filterByDynamicCriteria(newList, cleaned);
            } else {
              this.formattedUsers = newList.slice();
            }
          },
          formattedInfoOwnersSource(newList) {
            const cleaned = this._cleanFilterCriteria(this.infoOwnerFilterCriteria);
            if (Object.keys(cleaned).length > 0) {
              this.formattedInfoOwners = this.$nova.filterByDynamicCriteria(newList, cleaned);
            } else {
              this.formattedInfoOwners = newList.slice();
            }
          }
        }
      }
</script>